import { ComponentProps } from 'react';
import { getIsMobile } from '../../utils/getIsMobile';
import { px } from '../../utils/styles/px';
import { Flex } from '../layout/Flex';
import { DashboardHeader, DashboardHeaderProps, HEADER_HEIGHT } from './DashboardHeader';
import { DESKTOP_MENU_WIDTH } from './DashboardLayout';
import { SearchAppPanelStub } from './SearchAppPanelStub/SearchAppPanelStub';
import { CONTENT_ADAPTIVE_WIDTH_SCALE, CONTENT_WIDTH } from './constants';

interface DashboardPageProps extends ComponentProps<typeof Flex> {
    centered?: boolean;
    menuSlot?: DashboardHeaderProps['menuSlot'];
    backButtonEnabled?: boolean;
    adaptiveWidth?: boolean;
    hideHeader?: boolean;
    transparentHeader?: boolean;
    gridFeed?: boolean;
    fullHeight?: boolean;
}

export const DashboardPage = (props: DashboardPageProps) => {
    const {
        centered = true,
        menuSlot,
        backButtonEnabled,
        adaptiveWidth = false,
        gridFeed = false,
        children,
        hideHeader,
        transparentHeader,
        fullHeight,
        ...other
    } = props;
    const { isMobile } = getIsMobile();

    const maxWidth = adaptiveWidth ? `${CONTENT_ADAPTIVE_WIDTH_SCALE}dvw` : CONTENT_WIDTH;

    let width;
    if (adaptiveWidth) {
        width = 'auto';
    } else if (gridFeed) {
        width = `${CONTENT_ADAPTIVE_WIDTH_SCALE}dvw`;
    } else {
        width = '100%';
    }

    return (
        <Flex
            width="100%"
            minHeight={fullHeight ? '100vh' : '100%'}
            pr={{ lg: centered ? px(DESKTOP_MENU_WIDTH) : 0 }}
        >
            {!hideHeader && (
                <DashboardHeader
                    menuSlot={menuSlot}
                    backButtonEnabled={backButtonEnabled}
                    transparent={transparentHeader}
                />
            )}
            <Flex
                as="main"
                width={{ xs: '100%', sm: width }}
                minHeight="100%"
                mx={centered ? 'auto' : undefined}
                maxWidth={{ xs: 'none', sm: gridFeed ? width : maxWidth }}
                paddingTop={{
                    xs: transparentHeader || hideHeader ? 0 : HEADER_HEIGHT / 8,
                    sm: isMobile ? undefined : 0,
                }}
                {...other}
            >
                {children}
                <SearchAppPanelStub />
            </Flex>
        </Flex>
    );
};
